import React from 'react';

import { TableCell } from '@material-ui/core';
import PropTypes from 'prop-types';

import { BasicTable } from 'components/DebFormComponents/Table/BasicTable';
import { MyTaskTableRows } from 'components/MyTaskArea/MyTaskTable/MyTaskTableRows';

import './MyTaskTable.sass';

const headers = [
  <TableCell scope="task" key="Aufgabe">
    Aufgabe
  </TableCell>,
  <TableCell align="left" key="Zusatzinformation">
    Zusatzinformation
  </TableCell>,
  <TableCell align="left" key="Eingangsdatum">
    Eingangsdatum
  </TableCell>,
  <TableCell align="left" key="Status">
    Status
  </TableCell>,
  <TableCell align="right" key="Button" />,
];
export const MyTaskTable = ({ taskList, onTaskClick }) => {
  if (!taskList?.length) {
    return <div className="my-task-table-empty">Aktuell keine Aufgaben offen</div>;
  }
  const rows = <MyTaskTableRows tasks={taskList} onTaskClick={onTaskClick} />;

  return (
    <div className="my-task-table">
      <BasicTable headers={headers} rows={rows} />
    </div>
  );
};

MyTaskTable.propTypes = {
  taskList: PropTypes.array,
  onTaskClick: PropTypes.func,
};
MyTaskTable.defaultProps = {
  taskList: [],
  onTaskClick: undefined,
};
